module.exports = "js/webpack/b18448d804a3c629d1b8b9f03d894e04.svg";